module.exports = __webpack_public_path__ + "static/media/Servicio-Pasarela-Pagos-Credibanco-Colombia-4.cfd92a74.jpg";